import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "@mui/material";

const OverviewDialog = ({ open, close, handleSubmitData }) => {
  return (
    <Dialog open={open} fullWidth onClose={close}>
      <div className="p-4">
        <div>
          <span className="float-right text-20 cursor-pointer" onClick={close}>
            x
          </span>
          <h3 className="text-2C495D font-semibold text-xl"> AI Overview</h3>
        </div>

        <div>
          <p className="text-2C495D mt-2">
            Artificial intelligence (AI) in finance helps drive insights for data analytics, performance measurement,
            predictions and forecasting, real-time calculations, customer servicing, intelligent data retrieval, and
            more.
          </p>
        </div>
      </div>
    </Dialog>
  );
};

export default OverviewDialog;
